import { useFormikContext } from 'formik';
import React from 'react';
import { useFilePicker } from 'ud-form/components/file-picker';
import UDFormLabel from 'ud-form/components/label';
import UDButton from 'ud-ui/components/button';
import Text from 'ud-ui/components/text';

interface JsonFileFieldValues {
  jsonFile: File | null;
}

interface JsonFileFieldProps {
  /** Выбран новый файл — форма сбрасывает результат прошлого импорта. */
  onPicked: () => void;
}

/** Поле «JSON-файл» формы импорта: своя кнопка выбора и имя выбранного файла. Значение — поле `jsonFile` Formik. */
function JsonFileField({ onPicked }: JsonFileFieldProps) {
  const { values, errors, touched, setFieldValue, setFieldTouched } = useFormikContext<JsonFileFieldValues>();
  const picker = useFilePicker({
    accept: '.json,application/json',
    testId: 'json-file-input',
    onPick: (file) => {
      setFieldValue('jsonFile', file);
      setFieldTouched('jsonFile', true, false);
      onPicked();
    },
  });

  return (
    <div className="mb-3">
      <UDFormLabel>JSON-файл</UDFormLabel>
      <div className="flex flex-wrap items-center gap-3">
        {picker.input}
        <UDButton type="button" variant="secondary" onClick={picker.open}>
          Выбрать файл
        </UDButton>
        <Text type="subhead">{values.jsonFile ? values.jsonFile.name : 'Файл не выбран'}</Text>
      </div>
      {touched.jsonFile && errors.jsonFile ? (
        <Text type="caption-1" className="mt-2 text-red-500">
          {String(errors.jsonFile)}
        </Text>
      ) : null}
    </div>
  );
}

export default JsonFileField;
